module.exports = __webpack_public_path__ + "static/media/V3.c1dc5308.mp4";